import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5.25C7.6926 5.25 4.03589 8.04402 2.74776 11.9196C2.72989 11.9733 2.72981 12.0315 2.74768 12.0852C4.03877 15.9589 7.69457 18.75 12 18.75C16.3075 18.75 19.9641 15.956 21.2513 12.0806L21.2522 12.0778C21.2701 12.0246 21.2697 11.969 21.2526 11.9183L21.2515 11.9151C19.9605 8.04115 16.3056 5.25 12 5.25ZM1.3244 11.4462C2.81033 6.97587 7.02757 3.75 12 3.75C16.9705 3.75 21.1856 6.97285 22.6746 11.4409C22.7962 11.8027 22.7956 12.1934 22.6743 12.5548C21.1891 17.0247 16.972 20.25 12 20.25C7.02963 20.25 2.81352 17.0272 1.32451 12.5591C1.20438 12.1981 1.20432 11.8073 1.3244 11.4462Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9999 9.75C11.4032 9.75 10.8309 9.98705 10.4089 10.409C9.98696 10.831 9.74991 11.4033 9.74991 12C9.74991 12.5967 9.98696 13.169 10.4089 13.591C10.8309 14.0129 11.4032 14.25 11.9999 14.25C12.5966 14.25 13.1689 14.0129 13.5909 13.591C14.0129 13.169 14.2499 12.5967 14.2499 12C14.2499 11.4033 14.0129 10.831 13.5909 10.409C13.1689 9.98705 12.5966 9.75 11.9999 9.75ZM9.34826 9.34835C10.0515 8.64509 11.0053 8.25 11.9999 8.25C12.9945 8.25 13.9483 8.64509 14.6516 9.34835C15.3548 10.0516 15.7499 11.0054 15.7499 12C15.7499 12.9946 15.3548 13.9484 14.6516 14.6517C13.9483 15.3549 12.9945 15.75 11.9999 15.75C11.0053 15.75 10.0515 15.3549 9.34826 14.6517C8.645 13.9484 8.24991 12.9946 8.24991 12C8.24991 11.0054 8.645 10.0516 9.34826 9.34835Z"
        fill={colorValue}
      />
    </svg>
  );
};
